import React from 'react';
import Immutable from 'immutable';
import FormField from '../form/_Field';
import { connect } from 'react-redux';
import { getFormValues, getFormSyncErrors, reduxForm, change, touch } from 'redux-form/immutable';
import StateSelect from '../form/_StateSelect';
import PropTypes from 'prop-types';
import { validate } from '../../../lib/validate';
import { FORM_NAME } from '../../reps/premium/constants';
import { _renderCardElement } from './_renderCardElement';
import Button from '../form/_Button';
import { normalizeZipCode } from '../../../lib/fieldsNormalization';

class PaymentForm extends React.Component {
    onRenderCardElement = () => {
      const { onHandleSetCardValue } = this.props;

      return _renderCardElement({ onHandleChangeCardValue: this._handleChangeCardValue, onHandleSetCardValue });
    };

     _renderStateSelect = ({ input, meta, ...rest }) => {
       const value = input.value && input.value.length > 0 ? input.value : 'placeholder';

       return <StateSelect { ...input } { ...rest } value={ value } />;
     };

    _handleChangeCardValue = (value) => {
      const { changeFormData } = this.props;

      changeFormData('card', value);
    };

    render() {
      const { formValues, formSyncErrors, anyTouched, onHandleSubmit, valid, formTouch } = this.props;
      const errors = anyTouched ? formSyncErrors : Immutable.Map();

      return (

        <form onSubmit={ onHandleSubmit({ formValues, valid, anyTouched, formTouch }) }>
          <h2 className={ 'payment-form__section-header' }>
                Card Information:
          </h2>
          <FormField className={ 'payment-form__field' }
            component={ this.onRenderCardElement  }
            errors={ errors.get('card') }
            label={ 'card' }
            name={ 'card' } />
          <h2 className={ 'payment-form__section-header' }>
                Invoice Information:
          </h2>
          <FormField errors={ errors.get('name') } label={ 'Name' } name={ 'name' } value={ formValues.get('name') } />
          <FormField errors={ errors.get('address') } label={ 'Address' } name={ 'address' } value={ formValues.get('address') } />
          <FormField errors={ errors.get('city') } label={ 'City' } name={ 'city' } value={ formValues.get('city') } />
          <FormField errors={ errors.get('zipCode') } label={ 'Zip code' } name={ 'zipCode' } normalize={ normalizeZipCode } value={ formValues.get('zipCode') } />
          <FormField component={ this._renderStateSelect }
            errors={ errors.get('state') }
            inputClassName={ 'form__select' } label={ 'State' }
            name={ 'state' }
            value={ formValues.get('state') } />
          <div className='form__submit'>
            <Button className='form__button--green' >Confirm order</Button>
          </div>
        </form>
      );
    }
}

PaymentForm.propTypes = {
  anyTouched: PropTypes.bool.isRequired,
  changeFormData: PropTypes.func.isRequired,
  formSyncErrors: PropTypes.instanceOf(Immutable.Map),
  formTouch: PropTypes.func.isRequired,
  formValues: PropTypes.instanceOf(Immutable.Map),
  onHandleSetCardValue: PropTypes.func.isRequired,
  onHandleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => {
  return {
    formValues:  getFormValues(FORM_NAME)(state) || Immutable.Map(),
    formSyncErrors:  Immutable.Map(getFormSyncErrors(FORM_NAME)(state)) || Immutable.Map()
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeFormData: (state, value) => dispatch(change(FORM_NAME, state, value)),
    formTouch: () => dispatch(touch(FORM_NAME))
  };
};

export default (connect(mapStateToProps, mapDispatchToProps)(
  reduxForm(
    { form: FORM_NAME, touchOnBlur: false, validate }
  )(PaymentForm)
));



// WEBPACK FOOTER //
// ./app/components/shared/stripe/PaymentForm.jsx